import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { ActivatedRoute, Router } from '@angular/router';

/**
 * コープデリ職員初期表示画面
 *
 * @export EmployeeComponent
 * @class EmployeeComponent
 */
@Component({
  selector: 'app-employee',
  templateUrl: './employee.component.html',
  styleUrls: ['./employee.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EmployeeComponent implements OnInit {

  /**
   *Creates an instance of EmployeeComponent.
   * @param {KYMW00Model} kymw00Model
   * @param {ActivatedRoute} route
   * @param {Router} router
   * @memberof EmployeeComponent
   */
  constructor(
    public kymw00Model: KYMW00Model,
    private route: ActivatedRoute,
    private router: Router,
    ) {}

  /**
   * 初期処理
   *
   * @memberof EmployeeComponent
   */
  public ngOnInit(): void {
    var sp = '0';
    this.route.queryParams.subscribe((params) => {
      sp = params['sp'] ? params['sp'] : '0';
    });

    if (sp === '1') {
      // 認証検証画面に遷移
      this.router.navigate(['/auth'], { queryParams: { employee: '1' } });
    } else {
      // 認証検証画面起動
      this.authWindowOpen();
    }
  }

  /**
   * 別ウィンドウPEACE起動
   */
  public eventPeaceOpenHandler(): void {
    // 認証検証画面起動
    this.authWindowOpen();
  }

  /**
   * 認証検証画面起動
   */
  private authWindowOpen(): void {
    var sW = 0;
    sW = window.parent.screen.width;
    var sH = 0;
    sH = window.parent.screen.height;
    var ssW = 0;
    if (sW >= 1920) {
      ssW = 1920;
    } else {
      ssW = sW;
    }

    var ssH = 0;
    var optscb = '';
    if (sH >= 1080) {
      ssH = 1080;
      optscb = ', scrollbars=no';
    } else {
      ssH = sH;
      optscb = ', scrollbars=yes';
    }

    var url = '/auth?employee=1';
    var opt = 'width=' + ssW + ', height=' + ssH + ', menubar=no, toolbar=no, location=no' + optscb;
    window.open(url, null, opt);
    // window.closeするとポップアップブロックが分からないためクローズしない
    // window.close();
  }

}
